"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkTertiary = exports.buttonInfoOutlineFilledHover = exports.buttonInfoOutline = exports.buttonInfo = exports.buttonNoteOutlineFilledHover = exports.buttonNoteOutline = exports.buttonNote = exports.buttonWarningOutlineFilledHover = exports.buttonWarningOutline = exports.buttonWarning = exports.buttonTertiary = exports.buttonSecondary = exports.buttonPrimaryOutline = exports.buttonPrimary = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _base = require("./base");

var _swatches = require("../swatches");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var buttonPrimary = {
  background: _base.primary.brand,
  backgroundHover: _swatches.brand['700'],
  backgroundPressed: _swatches.brand['900'],
  backgroundDisabled: _swatches.brand['200'],
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _swatches.monochrome.white,
  textHover: _swatches.monochrome.white,
  textPressed: _swatches.monochrome.white,
  textDisabled: _swatches.monochrome.white
};
exports.buttonPrimary = buttonPrimary;
var buttonPrimaryOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _base.primary.brand,
  textHover: _swatches.brand['700'],
  textPressed: _swatches.brand['900'],
  textDisabled: _swatches.brand['200']
};
exports.buttonPrimaryOutline = buttonPrimaryOutline;
var buttonSecondary = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.brand,
  borderHover: _swatches.brand['700'],
  borderPressed: _swatches.brand['900'],
  borderDisabled: _swatches.brand['200'],
  text: _base.primary.brand,
  textHover: _swatches.brand['700'],
  textPressed: _swatches.brand['900'],
  textDisabled: _swatches.brand['200']
};
exports.buttonSecondary = buttonSecondary;
var buttonTertiary = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.superLight,
  backgroundDisabled: _swatches.monochrome.white,
  border: _swatches.monochrome.medium,
  borderHover: _swatches.monochrome.black,
  borderPressed: _swatches.monochrome.black,
  borderDisabled: _swatches.monochrome.medium,
  text: _swatches.monochrome.dark,
  textHover: _swatches.monochrome.black,
  textPressed: _swatches.monochrome.black,
  textDisabled: _swatches.monochrome.mediumDark
};
exports.buttonTertiary = buttonTertiary;
var buttonWarning = {
  background: _base.primary.negative,
  backgroundHover: _swatches.negative['700'],
  backgroundPressed: _swatches.negative['900'],
  backgroundDisabled: _swatches.negative['200'],
  border: _base.primary.negative,
  borderHover: _swatches.negative['700'],
  borderPressed: _swatches.negative['900'],
  borderDisabled: _swatches.negative['200'],
  text: _swatches.monochrome.white,
  textHover: _swatches.monochrome.white,
  textPressed: _swatches.monochrome.white,
  textDisabled: _swatches.monochrome.white
};
exports.buttonWarning = buttonWarning;
var buttonWarningOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.negative,
  borderHover: _swatches.negative['700'],
  borderPressed: _swatches.negative['900'],
  borderDisabled: _swatches.negative['200'],
  text: _base.primary.negative,
  textHover: _swatches.negative['700'],
  textPressed: _swatches.negative['900'],
  textDisabled: _swatches.negative['200']
};
exports.buttonWarningOutline = buttonWarningOutline;

var buttonWarningOutlineFilledHover = _objectSpread(_objectSpread({}, buttonWarningOutline), {}, {
  backgroundHover: _swatches.negative['50'],
  backgroundPressed: _swatches.negative['50'],
  borderHover: _base.primary.negative,
  textHover: _base.primary.negative
});

exports.buttonWarningOutlineFilledHover = buttonWarningOutlineFilledHover;
var buttonNote = {
  background: _base.primary.warning,
  backgroundHover: _swatches.warning['700'],
  backgroundPressed: _swatches.warning['900'],
  backgroundDisabled: _swatches.warning['200'],
  border: _base.primary.warning,
  borderHover: _swatches.warning['700'],
  borderPressed: _swatches.warning['900'],
  borderDisabled: _swatches.warning['200'],
  text: _swatches.monochrome.black,
  textHover: _swatches.monochrome.black,
  textPressed: _swatches.monochrome.black,
  textDisabled: "rgba(".concat(_swatches.monochrome.black_rgba, ", .5)")
};
exports.buttonNote = buttonNote;
var buttonNoteOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.warning,
  borderHover: _swatches.warning['700'],
  borderPressed: _swatches.warning['900'],
  borderDisabled: _swatches.warning['200'],
  text: _swatches.monochrome.black,
  textHover: _swatches.monochrome.black,
  textPressed: _swatches.monochrome.black,
  textDisabled: "rgba(".concat(_swatches.monochrome.black_rgba, ", .5)")
};
exports.buttonNoteOutline = buttonNoteOutline;

var buttonNoteOutlineFilledHover = _objectSpread(_objectSpread({}, buttonNoteOutline), {}, {
  backgroundHover: _swatches.warning['50'],
  backgroundPressed: _swatches.warning['50'],
  borderHover: _base.primary.warning
});

exports.buttonNoteOutlineFilledHover = buttonNoteOutlineFilledHover;
var buttonInfo = {
  background: _base.primary.info,
  backgroundHover: _swatches.info['600'],
  backgroundPressed: _swatches.info['700'],
  backgroundDisabled: _swatches.info['200'],
  border: _base.primary.info,
  borderHover: _swatches.info['700'],
  borderPressed: _swatches.info['700'],
  borderDisabled: _swatches.info['200'],
  text: _swatches.monochrome.white,
  textHover: _swatches.monochrome.white,
  textPressed: _swatches.monochrome.white,
  textDisabled: _swatches.monochrome.white
};
exports.buttonInfo = buttonInfo;
var buttonInfoOutline = {
  background: _swatches.monochrome.white,
  backgroundHover: _swatches.monochrome.white,
  backgroundPressed: _swatches.monochrome.white,
  backgroundDisabled: _swatches.monochrome.white,
  border: _base.primary.info,
  borderHover: _swatches.info['700'],
  borderPressed: _swatches.info['900'],
  borderDisabled: _swatches.info['200'],
  text: _base.primary.info,
  textHover: _swatches.info['700'],
  textPressed: _swatches.info['900'],
  textDisabled: _swatches.info['200']
};
exports.buttonInfoOutline = buttonInfoOutline;

var buttonInfoOutlineFilledHover = _objectSpread(_objectSpread({}, buttonInfoOutline), {}, {
  backgroundHover: _swatches.info['50'],
  backgroundPressed: _swatches.info['50'],
  borderHover: _base.primary.info,
  textHover: _base.primary.info
});

exports.buttonInfoOutlineFilledHover = buttonInfoOutlineFilledHover;
var linkTertiary = {
  text: _swatches.monochrome.black
};
exports.linkTertiary = linkTertiary;
//# sourceMappingURL=button.js.map